import { Component, OnInit, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { HttpService, UtilityService } from "services";
import { CustomValidations } from "custom-validations";
import { Router } from "@angular/router";


@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
  styleUrls: ["../../login/auth-wrapper.component.scss"],
})
export class UpdatePasswordComponent implements OnInit {
  @Input() isFirstLogin = false;
  profileForm: FormGroup;
  currentPassword: FormControl;
  password: FormControl;
  confirmPassword: FormControl;
  constructor(
    public dialogRef: MatDialogRef<UpdatePasswordComponent>,
    private http: HttpService,
    private fb: FormBuilder,
    private util: UtilityService,
    private router: Router
  ) {}

  ngOnInit() {
    this.createFormControls();
    this.createForm();
  }

  createFormControls() {
    this.currentPassword = new FormControl(
      "",
      this.isFirstLogin ? [] : Validators.required
    );
    this.password = new FormControl("", [
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#\$%\^&\*])(?!.*\s).{8,}$/
      ),
    ]);
    this.confirmPassword = new FormControl("", [Validators.required]);
  }

  createForm() {
    this.profileForm = this.fb.group(
      {
        oldPassword: this.currentPassword,
        password: this.password,
        confirmPassword: this.confirmPassword,
      },
      { validator: CustomValidations.MatchPassword }
    );
  }

  onSubmit() {
    if (this.profileForm.valid) {
      const data = {
        username: this.util.getUser(),
        password: this.password.value,
      };
      this.http
        .updatePassword(
          this.isFirstLogin ? "reset" : "change_password",
          this.isFirstLogin
            ? data
            : { ...data, oldPassword: this.currentPassword.value }
        )
        .subscribe(
          (res) => {
            if (res.ok) {
              this.util.showMsg(
                "Your password has been changed",
                "Successfully"
              );
              if (this.isFirstLogin) {
                // this.router.navigateByUrl('/user');
                // return window.location.reload();
                  localStorage.clear();
                  this.router.navigateByUrl("/u/login");
                  setTimeout(() => {
                    this.util.showMsg("Login to Continue", "");
                  }, 2000);
              } else {
                this.dialogRef.close();
                localStorage.clear();
                this.router.navigateByUrl("/u/login");
                setTimeout(() => {
                  this.util.showMsg("Login to Continue", "");
                }, 2000);
              }
            }
          },
          (err) => {
            this.http.errorMessage(err);
          }
        );
    } else {
      console.log(
        "FormData is Invalid",
        this.util.findInvalidControls(this.profileForm)
      );
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
